<div class="alert-bar-container">
  @if (zbpIconName) {
    <zbp-icon
      [iconName]="zbpIconName"
      hoveStyle="disabled"
      >
    </zbp-icon>
  }
  <div class="alert-bar-content">
    <ng-content></ng-content>
  </div>
</div>
